import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const SwatchIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/swatch"><g id="Icon"><path fillRule="evenodd" clipRule="evenodd" d="M3.90002 2.40039C3.0716 2.40039 2.40002 3.07196 2.40002 3.90039V18.0004C2.40002 19.9886 4.0118 21.6004 6.00002 21.6004C7.98825 21.6004 9.60002 19.9886 9.60002 18.0004V3.90039C9.60002 3.07196 8.92845 2.40039 8.10002 2.40039H3.90002ZM6.00002 19.2004C6.66277 19.2004 7.20002 18.6631 7.20002 18.0004C7.20002 17.3376 6.66277 16.8004 6.00002 16.8004C5.33728 16.8004 4.80002 17.3376 4.80002 18.0004C4.80002 18.6631 5.33728 19.2004 6.00002 19.2004Z" fill="currentColor" /><path d="M18.5158 10.5757L11.4 17.6915V7.50917L13.4246 5.48457C14.0104 4.89878 14.9602 4.89878 15.5459 5.48457L18.5158 8.45442C19.1016 9.0402 19.1016 9.98995 18.5158 10.5757Z" fill="currentColor" /><path d="M10.0368 21.6004H20.1C20.9284 21.6004 21.6 20.9288 21.6 20.1004V15.9004C21.6 15.072 20.9284 14.4004 20.1 14.4004H17.2368L10.0368 21.6004Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SwatchIcon;